// Draft-preview sites (staging) show unpublished edits while they are written.
// Visitors there browse in Next.js Draft Mode, which renders every page per
// request instead of from the cache, so no revalidate webhook is needed.
export const IS_DRAFT_PREVIEW =
  String(process.env.NEXT_PUBLIC_SANITY_PREVIEW).toLowerCase() === "true";

// Turns Draft Mode on, then returns to the `redirect` path.
export const DRAFT_PREVIEW_PATH = "/api/draft-preview/";
